import { FILTER_PREFIX, FILTER_SEPARATOR } from '../../constants/FacetConstants';

export default function formatFilterForQuery(fieldId, activeFiltersForField) {
  const key = `${FILTER_PREFIX}${fieldId}`;
  const value = activeFiltersForField.map(filter => filter.get('value')).join(FILTER_SEPARATOR);
  return { [key]: value };
}



// WEBPACK FOOTER //
// ./app/helpers/facets/formatFilterForQuery.js